import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

export const useDayPartSectionStyles = makeStyles((theme: Theme) =>
  createStyles({
    sectionGroup: {
      marginBottom: theme.spacing(1),
      borderRadius: theme.shape.borderRadius,
      overflow: 'hidden',
    },
    timeSlotRow: {
      marginBottom: 0,
    },
    weekGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(7, minmax(0, 1fr))',
      gap: theme.spacing(0.5),
      width: '100%',
    },
    dayCardGray: {
      padding: theme.spacing(0.5),
      backgroundColor: '#f5f5f5',
      borderRadius: theme.shape.borderRadius,
    },
    dayCardRed: {
      padding: theme.spacing(0.5),
      backgroundColor: '#ffebee',
      borderRadius: theme.shape.borderRadius,
    },
    serviceName: {
      fontSize: '0.75rem',
      fontWeight: 600,
      marginBottom: theme.spacing(0.5),
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
    serviceTime: {
      fontSize: '0.875rem',
      color: '#666',
    },
  }),
);
